import { render, staticRenderFns } from "./UploadMASSanctionList.vue?vue&type=template&id=6fc5598a&"
import script from "./UploadMASSanctionList.vue?vue&type=script&lang=js&"
export * from "./UploadMASSanctionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports